var date = {
  /**
   * Convert date to human readable format.
   *
   * @param date
   * @returns {string}
   */
  momentsAgo: function momentsAgo(date) {
    var diff = Math.round((new Date() - new Date(date)) / 1000);
    var minute = 60,
      hour = minute * 60,
      day = hour * 24,
      week = day * 7,
      month = day * 30,
      year = day * 365;
    var fuzzy;
    if (diff < 30) {
      fuzzy = 'just then';
    } else if (diff < minute) {
      fuzzy = diff + ' seconds ago';
    } else if (diff < 2 * minute) {
      fuzzy = 'a minute ago';
    } else if (diff < hour) {
      fuzzy = Math.floor(diff / minute) + ' minutes ago';
    } else if (Math.floor(diff / hour) === 1) {
      fuzzy = '1 hour ago';
    } else if (diff < day) {
      fuzzy = Math.floor(diff / hour) + ' hours ago';
    } else if (diff < day * 2) {
      fuzzy = 'yesterday';
    } else if (diff < week) {
      fuzzy = Math.floor(diff / day) + ' days ago';
    } else if (diff < week * 3) {
      fuzzy = Math.floor(diff / week) + ' weeks ago';
    } else if (diff < month) {
      fuzzy = Math.floor(diff / week) + ' weeks ago';
    } else if (diff < year) {
      fuzzy = Math.floor(diff / week) + ' months ago';
    }
    // June 28, 2015

    return fuzzy;
  }
};
export default date;